import React from 'react'
import PropTypes from 'prop-types'

import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

import Currency from 'react-currency-formatter';

//Lodash
import _map from 'lodash/map';
import _findIndex from 'lodash/findIndex';

const labelRadioOption = (name, price, currency) => {
    return (
        <span>{name} - <Currency quantity={price / 100} currency={currency}/></span>
    )
};

const createRadioOption = (item, index, currency, forceChangeCurrency) => {
    let priceIndex = _findIndex(item.prices, ['currency_code', currency]);

    // set default to GBP
    if (!item.prices[priceIndex]) {
        forceChangeCurrency();
        priceIndex = _findIndex(item.prices, ['currency_code', 'GBP']);
    }
        
    return (
        <RadioButton
        key={index}
        value={item.id}
        label= {labelRadioOption(item.name, item.prices[priceIndex].price, currency)}
        style={{marginBottom: 16}}
        />)
};

const ShippingOption = ({onSelect, seller_name, seller_id, currency, shippingOptions, selected, forceChangeCurrency}) => (
    <div className="shippingOption">
        {shippingOptions &&
        <RadioButtonGroup key={seller_id} name="zoneOptions" valueSelected={selected}
                          onChange={(e, v) => onSelect(seller_id, v)}>
            {_map(shippingOptions.zoneOptions, (item, index) => (
                createRadioOption(
                    item,
                    index,
                    currency,
                    forceChangeCurrency
                )
            ))}
        </RadioButtonGroup>
        }
        {!shippingOptions &&
        <p>No shipping options are available for your country</p>
        }
    </div>
);

ShippingOption.propTypes = {
    seller_id: PropTypes.string.isRequired,
    seller_name: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    shippingOptions: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.number.isRequired,
};

export default ShippingOption